import { render } from "./pnc_diagnosis.vue?vue&type=template&id=6fd0d03a&scoped=true"
import script from "./pnc_diagnosis.vue?vue&type=script&lang=js"
export * from "./pnc_diagnosis.vue?vue&type=script&lang=js"

import "./pnc_diagnosis.vue?vue&type=style&index=0&id=6fd0d03a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd0d03a"]])

export default __exports__